// This optional code is used to register a service worker.
// To use it, run `npm run build`, then serve your build folder (e.g., with serve -s build)

const isLocalhost = ['localhost', '127.0.0.1', '192.168.10.13'].includes(window.location.hostname);

export function register(config) {
  const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

  // Warn if in production and not HTTPS and not localhost
  if (
    process.env.NODE_ENV === 'production' &&
    window.location.protocol === 'http:' &&
    !isLocalhost
  ) {
    console.warn(
      'Service worker should be registered using HTTPS in production. ' +
      'See https://bit.ly/CRA-PWA for more information.'
    );
    // Continue anyway — useful for internal/local testing
  }

  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        registration.onupdatefound = () => {
          const installingWorker = registration.installing;
          if (installingWorker == null) return;

          installingWorker.onstatechange = () => {
            if (installingWorker.state === 'installed') {
              if (navigator.serviceWorker.controller) {
                // New content is available; show a message or refresh
                console.log(
                  'New content is available and will be used after all tabs are closed. ' +
                  'See https://bit.ly/CRA-PWA'
                );
              } else {
                // First time install — cached for offline use
                console.log('Content is cached for offline use.');
              }
            }
          };
        };
      })
      .catch((error) => {
        console.error('Error during service worker registration:', error);
      });
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.unregister();
    });
  }
}
